
  export default {
    name: 'DefaultLayout',
    mounted() {
      this.$store.dispatch('auth/loadAuthData') // Загрузка данных из localStorage
    },
  }
